import { Box, Typography, Button } from '@mui/material';
import PropTypes from 'prop-types';

export default function PageHeader({ title, subtitle, button, buttons, responsiveDirectionColumn }) {
  return (
    <Box
      className="fade-in"
      sx={{
        mb: { xs: 3, sm: 4 },
        mt: { xs: 2, sm: 3 },
        display: 'flex',
        flexDirection: responsiveDirectionColumn ? { xs: 'column', sm: 'row' } : { sm: 'row' },
        justifyContent: 'space-between',
        alignItems: { xs: 'flex-start', sm: 'center' },
        gap: { xs: 2, sm: 0 }
      }}
    >
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="h4"
          sx={{
            mb: subtitle ? 1 : 0,
            fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
            fontWeight: 700,
            lineHeight: 1.2
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              fontSize: { xs: '0.875rem', sm: '1rem' },
              maxWidth: '600px',
              lineHeight: 1.5
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
      {button && (
        <Button
          variant="contained"
          color={button.color || 'primary'}
          startIcon={button.icon}
          onClick={button.onClick}
          sx={{
            mt: { xs: 1, sm: 0 },
            px: { xs: 3, sm: 4 },
            py: { xs: 1, sm: 1.5 },
            boxShadow: 'none',
            '&:hover': {
              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
            },
            transition: 'all 0.2s ease-in-out'
          }}
        >
          {button.text}
        </Button>
      )}

      {buttons && (
        buttons
      )}

    </Box>
  );
}

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  button: PropTypes.shape({
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    icon: PropTypes.node,
    color: PropTypes.string
  }),
  buttons: PropTypes.node,
  responsiveDirectionColumn: PropTypes.bool
};
